//
//
//
//
import barChart from '@/components/bigDataChart/barChart'; // import { querySewageQuota } from '@/api/api'
// import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'waterType',
  //   mixins: [listenMapChange],
  // created() {
  //   this.queryWaterType()
  // },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    waterTitle: {
      type: String,
      default: ''
    }
  },
  components: {
    barChart: barChart
  },
  methods: {
    queryWaterType: function queryWaterType(areaId, projectId) {
      var _this = this;

      var data = {
        xData: ['I 类[河流]', 'III类[湖库]', 'IV类[湖库]', 'Ⅱ类[河流]', '劣V类[湖库]', '达标[餐废出水]', 'IV类[河流]', '劣V类[河流]'],
        yData: [1, 1, 1, 2, 1, 1, 1, 1]
      };
      console.log(this.waterTitle, "waterTitle");
      setTimeout(function () {
        _this.$refs.chart4.initBarChart(data, 'red', _this.waterTitle);
      }, 1000);
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWaterType(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWaterType(value, this.currentProjectId)
  //     },
  //   },

};